import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import md5 from 'md5';
import { FormattedMessage } from 'react-intl';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/process.home.actions';
import * as actionsManageProcess from '../../../../actions/api.manage.process.actions';
import Snackbar from '../../../labels/Snackbar';

import Grid from '@material-ui/core/Grid';
import Fab from '@material-ui/core/Fab';

import AddProcess from './ProcessAdd';

import Check from './Check';
import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';

import { AddIcon } from '../../../../images/icons/WrapSvg';

class Families extends React.Component {
    state = {
        openFamily: false,
        openProcess: false,
        name: '',
    };

    static getDerivedStateFromProps(props, state) {
        const { family, manage_process, info, window_searchs, active } = props;
        if (
            active !== state.active ||
            family !== state.family ||
            manage_process !== state.manage_process ||
            window_searchs !== state.window_searchs
        ) {

            const { families } = manage_process;
            if (families && family && state.family !== family) {

                const info = families.find((f) => f.codigo === family);
                if (info !== undefined) {
                    state.name = info.nombre;
                    props.setCurrentWindow(info.nombre);
                    props.setSearch(true);
                } else {
                    props.setCurrentWindow(family);
                    props.setSearch(true);
                }
            }
            console.log("families", families, manage_process);

            state.window_searchs = window_searchs;
            state.family = family;
            state.manage_process = manage_process;
            state.families = families;
            state.active = active;

            state.locals =
                window_searchs &&
                    window_searchs.length > 0 &&
                    info &&
                    info.security &&
                    info.security.locals
                    ? info.security.locals
                        .filter((f) =>
                            window_searchs.some((s) => f.path.toUpperCase().includes(s)),
                        )
                        .map((l) => l.id.toString())
                    : [];

            let data = undefined;
            if (families && family) {
                const aux = families.find((item) => item.codigo === family);
                if (aux !== undefined) {
                    data = aux.processes.filter(
                        (f) =>
                            f.status !== 'deleted' &&
                            ((window_searchs.length === 0 && window_searchs.length === 0) ||
                                window_searchs.some(
                                    (s) => f.nombre && f.nombre.toUpperCase().includes(s),
                                ) ||
                                window_searchs.some(
                                    (l) =>
                                        f.programacion && f.programacion.toUpperCase().includes(l),
                                )),
                    );
                }
            } else if (families) {
                data = families.filter(
                    (f) =>
                        f.status !== 'deleted' &&
                        (!window_searchs ||
                            window_searchs.length === 0 ||
                            f.processes.some(
                                (p) =>
                                    p.status !== 'deleted' &&
                                    (window_searchs.some(
                                        (s) => p.nombre && p.nombre.toUpperCase().includes(s),
                                    ) ||
                                        state.locals.some(
                                            (l) =>
                                                p.programacion &&
                                                p.programacion.toUpperCase().includes(l),
                                        )),
                            )),
                );
            }

            state.sortedData = !data
                ? undefined
                : []
                    .concat(data)
                    .sort((a, b) => (a.nombre.toUpperCase() < b.nombre.toUpperCase() ? -1 : 1))
                    .map((item, index) => (
                        <Check
                            key={item.codigo}
                            data={item}
                            last={data.length === index + 1}
                            active={item.codigo === active}
                            family={family}
                        />
                    ));


        }
        return null;
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleBack = () => {
        if (this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }
    };

    handleClick = (e) => {
        this.setState({ openProcess: true });
    };

    handleClose = (e) => {
        this.setState({
            openFamily: false,
        });
    };

    handleCloseProcess = (e) => {
        this.setState({
            openProcess: false,
        });
    };

    handleCloseLabel = (event) => {
        this.setState({ error: false });
    };

    addElementProcess = (data) => {
        this.setState({
            openProcess: false,
        });
        this.props.addProcess(data, md5(data.familia))
            .catch((error) => {
                console.error(error);
                this.setState({ error: error.message, errorType: error.type })
            });
    };

    render() {
        const { openProcess, name, sortedData, error, errorType } = this.state;
        const { family, code, manage_process_is_loading, manage_process_has_error, info } = this.props;
        const addAvailable = info && info.security && info.security.licencias && info.security.licencias.some((f) => f.id === 150 && f.activo && (f.quota > f.quotaUsed || f.quota === -1));
        const licencia = info && info.security && info.security.licencias ? info.security.licencias.find((f) => f.id === 150) : undefined;

        if (manage_process_has_error.hasErrored) {
            return (
                <Error
                    open
                    type={manage_process_has_error.hasErrored}
                    message={manage_process_has_error.error}
                    handleClose={this.handleBack}
                />
            );
        } else {
            return (
                <div className={'flex_full_column padding_bottom_9 height100'}>
                    {manage_process_is_loading && <Loading open opacity />}
                    <div
                        className="flex_full overflow_y_scroll showbar"
                        onScroll={this.handleScroll}
                    >
                        {code === 1 &&
                            <div className={"flex_auto_row c_white padding_borders center " + ((!licencia || licencia.quota === -1 || licencia.quotaUsed / licencia.quota < 0.50) ? "bg_pealigth" : "bg_lipstickligth")}>
                                <FormattedMessage id={"form_field_name_amount"} />
                                {(licencia && licencia.quota !== -1) &&
                                    <span>{": " + licencia.quotaUsed + " / " + licencia.quota}</span>
                                }
                                {(licencia && licencia.quota === -1) &&
                                    <span>{": " + licencia.quotaUsed}</span>
                                }
                            </div>
                        }
                        <Grid container>
                            {sortedData &&
                                sortedData.map((info) => {
                                    return info;
                                })}
                        </Grid>
                        {(code === 1 || (code === 2 && family)) && (
                            <Fab
                                aria-label="add"
                                disabled={!addAvailable}
                                className={'button_float ' + (addAvailable ? ' bg_bluish c_white' : ' bg_disabled c_white')}
                                onClick={this.handleClick}
                            >
                                <AddIcon />
                            </Fab>
                        )}
                    </div>
                    {openProcess && (
                        <AddProcess
                            {...this.props}
                            title="form_add_process_title"
                            open={openProcess}
                            familyName={name}
                            onClose={() => this.handleCloseProcess()}
                            add={this.addElementProcess}
                        />
                    )}
                    {error && (
                        <Snackbar
                            open={error}
                            variant={errorType ? errorType : "error"}
                            text={error}
                            nonavbar={true}
                            onClose={this.handleCloseLabel}
                        />
                    )}
                </div>
            );
        }
    }
}

Families.propTypes = {
    manage_process: PropTypes.object.isRequired,
    manage_process_is_loading: PropTypes.bool.isRequired,
    manage_process_has_error: PropTypes.object.isRequired,
    window_searchs: PropTypes.array.isRequired,
    info: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        manage_process: state.manage_process,
        manage_process_is_loading: state.manage_process_is_loading,
        manage_process_has_error: state.manage_process_has_error,
        window_searchs: state.window_searchs,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsManageProcess), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Families));



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/Families.js